import React from 'react';
import PortfolioPostIntro from '../components/portfolio-post/PortfolioPostIntro';
import PortfolioPostSlider from '../components/portfolio-post/PortfolioPostSlider';
import PortfolioPostMeta from '../components/portfolio-post/PortfolioPostMeta';
import PortfolioPostChallenge from '../components/portfolio-post/PortfolioPostChallenge';
import PortfolioPostApproach from '../components/portfolio-post/PortfolioPostApproach';
import PortfolioPostSolution from '../components/portfolio-post/PortfolioPostSolution';
import PortfolioPostResults from '../components/portfolio-post/PortfolioPostResults';
import NextPost from '../components/NextPost';

const PortfolioPostPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <PortfolioPostIntro />
                <PortfolioPostSlider />
                <PortfolioPostMeta />
                <PortfolioPostChallenge />
                <PortfolioPostApproach />
                <PortfolioPostSolution />
                <PortfolioPostResults />
                <NextPost />
            </div>
        </main>
    );
};

export default PortfolioPostPage;
